module.exports = __webpack_public_path__ + "img/bb-alston.ce7bcd43.png";